import * as sections from "./components/sections/index.mjs";
import sectionsWithDataProps from "./sections-info.mjs";
import { sectionsSchemas } from "./zod/index.mjs";
import sectionsConfig from "./ab-sections.config.json";
const availableSections = sectionsConfig.sections;
const componentsWithDetails = availableSections.map(
  ({ name, id, category, presets }) => ({
    name,
    id,
    category,
    presets,
    component: sections[name]
  })
);
const sectionsSchemasByName = availableSections.reduce(
  (acc, curr) => ({
    ...acc,
    [curr.name]: sectionsSchemas[curr.name]
  }),
  {}
);
function forEachSections(callback) {
  Object.keys(sections).forEach((key) => {
    callback(key, sections[key]);
  });
}
export {
  componentsWithDetails,
  sectionsWithDataProps,
  sectionsSchemasByName,
  sections,
  forEachSections
};
